import React from "react";
import { Typography } from "@mui/material";

const PLATFORM_LABELS = { ios: "iOS", android: "Android", web: "Web" };

export const formatCountry = (code) => {
  if (!code) return null;
  try {
    return new Intl.DisplayNames(["en-GB"], { type: "region" }).of(code) || code;
  } catch {
    return code;
  }
};

export const formatPlatform = (platform) =>
  platform ? PLATFORM_LABELS[String(platform).toLowerCase()] || platform : null;

/** Last seen time, then platform · country, for any user (users.last_seen_at etc.). */
const LastSeenInfo = ({ user }) => {
  const seen = user?.last_seen_at ? new Date(user.last_seen_at) : null;
  const meta = [formatPlatform(user?.mobile_platform), formatCountry(user?.last_seen_country)]
    .filter(Boolean)
    .join(" · ");

  return (
    <>
      <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
        {seen && !Number.isNaN(seen.getTime())
          ? seen.toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
          : "Never"}
      </Typography>
      {meta ? (
        <Typography variant="caption" display="block" sx={{ color: "#9aa1ac" }}>
          {meta}
        </Typography>
      ) : null}
    </>
  );
};

export default LastSeenInfo;
